import { render, staticRenderFns } from "./WorkActionsBorrow.vue?vue&type=template&id=45d078e0&scoped=true&"
import script from "./WorkActionsBorrow.vue?vue&type=script&lang=js&"
export * from "./WorkActionsBorrow.vue?vue&type=script&lang=js&"
import style0 from "./WorkActionsBorrow.vue?vue&type=style&index=0&id=45d078e0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d078e0",
  null
  
)

export default component.exports